// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Layout } from '../../components/index';
import { AreMissing } from './Views/AreMissing/AreMissing';
import { Contact } from './Views/Contact/Contact';
import { Hero } from './Views/Hero/Hero';
import { MarketSays } from './Views/MarketSays/MarketSays';
import { Showcase } from './Views/Showcase/Showcase';
import { Testimonials } from './Views/Testimonials/Testimonials';

export const Home = () => {
  const routePath = useLocation();

  const onTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    onTop();
  }, [routePath]);

  return (
    <Layout>
      <Hero />
      <Showcase />
      <Testimonials />
      <MarketSays />
      <AreMissing />
      <Contact />
    </Layout>
  );
};
